import Color from '@/Enums/Color.enum';
import { WhitelabelType } from '@/Enums/Whitelabels/WhitelabelType.enum';
import { Chip, chipClasses } from '@mui/material';

interface IProps {
  value: boolean;
}

const WhitelabelTypeChip = ({ value }: IProps) => {
  const label = value ? WhitelabelType.Whitelabel : WhitelabelType.Organization;
  return (
    <Chip
      sx={[
        {
          height: '25px',
          padding: '8px',
          borderRadius: '32px',
          [`& .${chipClasses.label}`]: {
            padding: '0 2px',
            fontSize: 12,
            fontWeight: 500,
          },
          [`& .${chipClasses.icon}`]: {
            width: '14px',
            margin: 0,
          },
        },
        value
          ? {
              background: 'rgba(255, 87, 77, 0.12)',
            }
          : {
              background: 'rgba(27, 67, 50, 0.12)',
            },
        value
          ? {
              color: Color.AccentRed,
            }
          : {
              color: Color.Primary,
            },
      ]}
      label={label}
      role='presentation'
      title={label}
    />
  );
};

export default WhitelabelTypeChip;
